export const BLUEPRINT_VARIANT = 'variant';
export const DISCOUNT_CODE_APPLIED = 'discount_code_applied';
